import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {getLoginLink} from 'src/openapi/admin/apis/LoginLinkControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {GetLoginLinkResponse} from 'src/openapi/admin/models/GetLoginLinkResponse';

type Props = {
    userId: number,
    onSuccess: (data: GetLoginLinkResponse) => void,
    onFail: (error: string) => void,
};

export const useGenerateLoginLink = ({userId, onFail, onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        getLoginLink({userId}),
    ), [userId, apiDispatch]);

    return useCommonEventHook<GetLoginLinkResponse>({eventAction, onFail, onSuccess});
};
